import { render, staticRenderFns } from "./UserPicklDetailsPopupOverview.vue?vue&type=template&id=37369c22&scoped=true&"
import script from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
export * from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserPicklDetailsPopupOverview.vue?vue&type=style&index=0&id=37369c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37369c22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37369c22')) {
      api.createRecord('37369c22', component.options)
    } else {
      api.reload('37369c22', component.options)
    }
    module.hot.accept("./UserPicklDetailsPopupOverview.vue?vue&type=template&id=37369c22&scoped=true&", function () {
      api.rerender('37369c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UserPicklDetailsPopupOverview.vue"
export default component.exports